import { render } from "./LabelSearchField.vue?vue&type=template&id=bbeeff04"
import script from "./LabelSearchField.vue?vue&type=script&lang=js"
export * from "./LabelSearchField.vue?vue&type=script&lang=js"

import "../styles/LabelSearchField.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__